<template>
    <div class="sentinel-container">
        <input ref="input" placeholder="输入密码" type="password"/>
        <div>
            <button class="button"
                    v-for="(label, action) in actions"
                    :key="action"
                    @click="performAction(action)">
                {{label}}
            </button>
        </div>
        <pre>{{output}}</pre>
    </div>
</template>

<script>
	import SentinelService from "../services/SentinelService";

	export default {
		name: "Sentinel.vue",
        data() {
			return {
				actions: {
					"www-status": "网页后台状态",
					"www-restart": "重启网页后台",
					"www-stop": "停止网页后台",
					"db-status": "数据库状态",
					"db-restart": "重启数据库",
					"db-stop": "停止数据库",
				},
                output: "输出"
            }
        },
		methods: {
			performAction(action) {
				let key = this.$refs.input.value;
				SentinelService.post(action, key).then(result => {
                    this.output = result;
				}).catch(error => {
                    this.output = "网络错误/身份验证错误\n" + error;
				})
			}
		}
	}
</script>

<style scoped lang="scss">
    .sentinel-container {
        display: flex;
        flex-direction: column;
        padding: 64px;
        overflow: hidden;
        box-sizing: border-box;
    }

    button, input {
        font-size: 16px;
        margin: 8px 8px;
    }

    pre {
        background-color: $p-fg;
        color: $p-bg;
        padding: 16px;
        font-size: 16px;
        flex-grow: 1;
        overflow: scroll;
        font-family: "Menlo", "Courier New", monospace;
    }
</style>